import React from 'react';
import { Facebook, Instagram, Twitter } from 'lucide-react';
import { openSupportEmail } from '@/lib/support';
import { Logo } from './Header';


const Footer: React.FC = () => {
  return (
    <footer>
      {/* Footer brand card */}
      <div className="bg-gradient-to-b from-white via-fuchsia-50 to-purple-50 border-t border-fuchsia-100 py-10">
        <div className="max-w-6xl mx-auto px-4">
          <div className="rounded-3xl bg-gradient-to-r from-purple-800 via-fuchsia-700 to-pink-500 border border-fuchsia-200 px-5 py-5 shadow-xl">
            <div className="flex items-center gap-4">
              <img
                src="/brand/kinscircle-tree-icon.png"
                alt="KinsCircle"
                className="w-20 h-20 rounded-2xl shadow-md flex-shrink-0"
              />
              <div className="w-px self-stretch bg-white/40"></div>
              <div className="text-white text-lg font-medium leading-relaxed">
                We look forward to you becoming a part of the <span className="font-semibold">KinsCircle experience.</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="bg-gradient-to-b from-purple-50 via-fuchsia-50 to-white text-slate-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10">
            <div className="lg:col-span-2">
              <div className="font-serif text-xl font-bold text-slate-900 mb-3">
                Kins<span className="bg-gradient-to-r from-pink-400 to-fuchsia-400 bg-clip-text text-transparent">Circle</span>
              </div>
              <p className="text-sm text-slate-600 mb-5 max-w-md">
                A private family operating system for modern families. Build your living family network, preserve memories across generations, share moments with the people who matter, and grow the relationships that last.
              </p>
            </div>

            <div>
              <h4 className="font-serif text-base font-bold text-slate-900 mb-4">Explore</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#tree" className="hover:text-slate-900 transition-colors">Family Tree</a></li>
                <li><a href="#gallery" className="hover:text-slate-900 transition-colors">Memory Archive</a></li>

                <li><a href="#events" className="hover:text-slate-900 transition-colors">Events</a></li>
                <li><a href="#pricing" className="hover:text-slate-900 transition-colors">Pricing</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-serif text-base font-bold text-slate-900 mb-4">Family Tools</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="/app" className="hover:text-slate-900 transition-colors">Voice & Video Calls</a></li>
                <li><a href="/app" className="hover:text-slate-900 transition-colors">Family Messaging</a></li>
                <li><a href="/app" className="hover:text-slate-900 transition-colors">Family News</a></li>
                <li><a href="#events" className="hover:text-slate-900 transition-colors">Family Events</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-serif text-base font-bold text-slate-900 mb-4">Support</h4>
              <ul className="space-y-2 text-sm">
                <li><button onClick={() => openSupportEmail()} className="hover:text-slate-900 transition-colors">Get Help</button></li>
                <li><button onClick={() => openSupportEmail()} className="hover:text-slate-900 transition-colors">Contact Support</button></li>
                <li><a href="/privacy" className="hover:text-slate-900 transition-colors">Privacy &amp; Safety</a></li>
                <li><a href="/terms" className="hover:text-slate-900 transition-colors">Terms of Service</a></li>
              </ul>
            </div>

          </div>

          <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-xs text-slate-500">© 2026 KinsCircle. Preserving memories, one generation at a time.</div>
            <div className="flex items-center gap-3">
              {[Facebook, Instagram, Twitter].map((Icon, i) => (
                <button key={i} onClick={() => toast('Follow us!')} className="w-9 h-9 rounded-full bg-slate-900 hover:bg-slate-800 border border-slate-800 flex items-center justify-center transition-colors">
                  <Icon className="w-4 h-4 text-slate-600" />
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
